// removed by extract-text-webpack-plugin
module.exports = {"Auth":"Auth__-loca-__1TInt","ButtonGroup":"Auth__-loca-__3AXlF","ModalText":"Auth__-loca-__KcVkZ","OtherOptions":"Auth__-loca-__3yKCE","Signup":"Auth__-loca-__2TWWx","Title":"Auth__-loca-__SO5a_","Error":"Auth__-loca-__25GIB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Auth.css
// module id = 255
// module chunks = 0